<div style="margin-left: 1rem;" *ngIf="!isshowLoader">
  <p class="repair-header">{{'Symptom evaluation will now be performed'|translate}}:</p>
  <img src="assets/images/ajax-loader.gif" width="40" height="40">
</div>
<ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" style="margin-top: 5%;" color="#003478" size="medium"
  type="ball-spin-clockwise">
  <p style="font-size: 20px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;"></p>
</ngx-spinner>
<div *ngIf="!showNoCandidate && clickShowNoconnection && isshowLoader" class="main">
  <h5>{{'Diagnostic Procedures'|translate}}</h5>
  <p class="info-title">{{'info text1'|translate}}</p>
  <div class="table">
    <table style="width: 100%">
      <thead>
        <tr>
          <th style="width: 12%;">{{'Rating'|translate}}</th>
          <th style="width: 10%;">DTC Info</th>
          <th style="width: 30%;">{{'Diagnostic Procedure'|translate}}</th>
          <th style="width: 12%;">{{'State'|translate}}</th>
          <th style="width: 14%;">&nbsp;</th>
          <th style="width: 10%;">{{'Last Updated'|translate}}</th>
          <th style="width: 12%;">{{'Skip not relevant'|translate}}</th>
          <th style="width: 2%;">&nbsp;</th>
          <th style="width: 2%;"><input type="checkbox" class="selectAllCheckBoxStyle" data-tip="Select Or Deselect All"
              *ngIf="isShowSkipCheckbox" [disabled]="isDisableSelectAllCheckbox" (change)="selectAllCheckbox($event)"
              [(ngModel)]="checkAll"></th>
        </tr>
      </thead>
      <tbody>
        <tr mdbTableCol *ngFor="let i of candidateArray, let ind=index">
          <th *ngIf="i.rating=='5'">
            <span *ngFor="let q of [5,5,5,5,5] ">
          <td>
            <div class="box"></div>
          </td>
          </span>
          </th>
          <th *ngIf="i.rating=='4'">
            <span *ngFor="let q of [4,4,4,4] ">
          <td>
            <div class="box"></div>
          </td>
          </span>
          </th>
          <th *ngIf="i.rating=='3'">
            <span *ngFor="let q of [3,3,3] ">
          <td>
            <div class="box"></div>
          </td>
          </span>
          </th>
          <th *ngIf="i.rating=='2'">
            <span *ngFor="let q of [5,5] ">
          <td>
            <div class="box"></div>
          </td>
          </span>
          </th>
          <th *ngIf="i.rating=='1'">
            <span>
          <td>
            <div class="box"></div>
          </td>
          </span>
          </th>
          <td>
            <a href="javascript: void(0)" (click)="ShowDTCInformation(i.ruleDetails,CandidateDtcInfo,i.id)">DTC Info</a>
          </td>
          <td>
            <img
              *ngIf="'PINPOINT-CANDIDATE' == i.kind || 'REPAIR-INFO-CANDIDATE' == i.kind || 'OTX-SERVFUNC-CANDIDATE' == i.kind"
              src="assets/images/pinpoint-red.gif">
            <img
              *ngIf="'TSB-CANDIDATE' == i.kind || 'GENERAL-INFORMATION-CANDIDATE' == i.kind || 'ETIS-CANDIDATE' == i.kind || 'OTX-CANDIDATE' == i.kind || 'OTX_DIAGNOSTIC-CANDIDATE' == i.kind"
              src="assets/images/pinpoint.gif">
            {{i.title}}
          </td>
          <td
            [ngStyle]="{'color': i.state == 'fail - Fault found' || i.state == 'Error' ? 'red' : (i.state == 'View' || i.state == 'Unread' || i.state == 'Untested') ? 'gray' : 'green'}">
            {{i.state|translate|titlecase}}</td>
          <td *ngIf="!candidateFailed && !i.isDisableTestViewBtns">
            <button
              *ngIf="'OTX-CANDIDATE' == i.kind || 'OTX_DIAGNOSTIC-CANDIDATE' == i.kind || 'OTX-SERVFUNC-CANDIDATE' == i.kind"
              class="button"
              (click)="navigateToFdrsView(i.procUidRef,content,networkTestConfirmation,false,i.kind,i.rating,i.title,i.procUidRef,i.uidRef,'TEST',ind,i.state)">{{'TEST'|translate}}
            </button>
            <button *ngIf="(i.state == 'View' || i.state == 'Unread')" class="button"
              (click)="navigateToFdrsView(i.procUidRef,content,networkTestConfirmation,false,i.kind,'','','i.procUidRef','i.uidRef','VIEW',ind,i.state)">{{'VIEW'|translate}}
            </button>
            <button
              *ngIf="('PINPOINT-CANDIDATE' == i.kind || 'REPAIR-INFO-CANDIDATE' == i.kind || 'TSB-CANDIDATE' == i.kind || 'GENERAL-INFORMATION-CANDIDATE' == i.kind || 'ETIS-CANDIDATE' == i.kind) && (i.state == 'Viewed' || i.state == 'Pass - no Fault' || i.state == 'Error')"
              class="button"
              (click)="navigateToFdrsView(i.procUidRef,content,networkTestConfirmation,false,i.kind,'','','i.procUidRef','i.uidRef','READ',ind,i.state)">{{'Read'|translate}}
            </button>
          </td>
          <td *ngIf="candidateFailed || i.isDisableTestViewBtns"></td>
          <td>{{i.lastUpdatedDate|date:'dd MMM yyyy'}}</td>
          <td style="text-align: center"><input *ngIf="isShowSkipCheckbox" [disabled]="i.isCheckBoxDisable"
              type="checkbox" (change)="changeStatetoSkip(i.procUidRef,ind,i.state)" [(ngModel)]="i.isCheckBoxSelected">
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="box1"></div>
  <div class="box1"></div>
  <div class="box1"></div>
  <div class="box1"></div>
  <div class="box1"></div>
  <div style="padding-top: 1%; color: grey;"><i>{{'Confidence rating'|translate}}</i></div>
  <div *ngIf="isDiagnosticViewFaultFound">
    <!--If Fault Found -->
    <label class="title" style="font-size: 0.8rem;">{{'Component/Repair Type Identified'|translate}}</label>
    <br>
    <label class="title" style="font-size: 0.75rem;">{{'Faulty Component Or Repair Types'|translate}}</label>
    <br>
    <label class="data" style="font-size: 0.8rem;">{{faultString}}</label>
    <br>
    <label class="title" style="font-size: 0.75rem;">{{'Failure Condition'|translate}}:</label>
    <br>
    <label class="data" style="font-size: 0.8rem;">{{'UnKnown'|translate}}</label>
    <br>
    <label class="data" style="font-size: 0.75rem;">{{'Proceeding repair info'|translate}}:</label>
    <br>
    <button class="buttons" (click)="navigateCustomerPaidView()">{{'Continue'|translate}}</button>
  </div>
  <div style="text-align:center; margin-top:-10%" *ngIf="FDRSStatusLoader">
    <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>
  </div>
  <div>
    <button class="buttons" (click)="closeBtnClick()">{{'Pause_btn'|translate}}</button>
    <button class="buttons" (click)="cancelBtnClick()">{{'End_btn'|translate}}</button>
    <button class="buttons" [disabled]="changeSymptoms" (click)="callSymptom()">{{'CHANGE SYMPTOMS'|translate}}</button>
    <button *ngIf="showManual" class="buttons" (click)="manualOnClick(content,networkTestConfirmation)">{{'MANUAL DIAGNOSIS'|translate}}</button>
  </div>
</div>
<br />
<div *ngIf="!clickShowNoconnection && showNoCandidate && isshowLoader" class="candidate-error">
  <div *ngIf="flag == false" style="border: solid 2px #b82b29; border-radius: 6px; margin-bottom: 0.5rem">
    <p style="color: red; padding-top: 0.3rem;">
      <i class="fa fa-exclamation-triangle" style="color: #b82b29; margin: 0 0.3rem;"></i>
      <span>{{'No candidates found due to an error'|translate}}</span>
    </p>
  </div>
  <p style="color: red;" *ngIf="flag == true">{{'No candidates found due to connectivity issue'|translate}}</p>
  <p>{{'info text2'|translate}}</p>
  <div>
    <button class="buttons" (click)="closeBtnClick()">{{'Pause_btn'|translate}}</button>
    <button class="buttons" (click)="cancelBtnClick()">{{'End_btn'|translate}}</button>
    <button class="buttons" (click)="callSymptom()">{{'CHANGE SYMPTOMS'|translate}}</button>
    <button class="buttons" (click)="manualOnClick(content,networkTestConfirmation)">{{'MANUAL DIAGNOSIS'|translate}}</button>
  </div>
</div>
<div *ngIf="isShowCandidateWhenNull && isshowLoader" class="candidate-error">{{'info text3'|translate}}
  <div>
    <button class="buttons" (click)="closeBtnClick()">{{'Pause_btn'|translate}}</button>
    <button class="buttons" (click)="cancelBtnClick()">{{'End_btn'|translate}}</button>
    <button class="buttons" (click)="callSymptom()">{{'CHANGE SYMPTOMS'|translate}}</button>
    <button class="buttons" (click)="manualOnClick(content,networkTestConfirmation)">{{'MANUAL DIAGNOSIS'|translate}}</button>
  </div>
</div>
<div id="overlay" *ngIf="saveInProgress">
  <span id="nav-spinner">
    <img src="assets/images/ajax-loader.gif" width="80" height="80">
  </span>
</div>

<ng-template #content let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Information'|translate}}</div>
      <i class="fa fa-times" style="cursor: pointer" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="info-s">
      <p>{{'Diagnosis and Repair info'|translate}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="buttons" (click)="modal.dismiss('Cross click')">{{'Continue'|translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #networkTestConfirmation let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Information'|translate}}</div>
      <i class="fa fa-times" style="cursor: pointer" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="info-s">
      <p>{{'No current Network Test results available'|translate}}: {{'Network Test Message2'|translate}}. {{'Please
        ensure that the GFDRS client is connected'|translate}}.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="buttons"
        (click)="modal.dismiss('Cross click');navigateToNetworkTest()">{{'YES'|translate}}</button>
      <button type="button" class="buttons"
        (click)="modal.dismiss('Cross click');dismissNetworktestInfoPopup()">{{'NO'|translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #CandidateDtcInfo let-modal>
  <div class="modal-content">
    <div class="modal-header" style="height: 30px;">
      <div class="mng-qualifier-header-popup" id="exampleModalLongTitle">DTC Information for the candidateId - {{dtcCandidateId}}</div>
      <i class="fa fa-times" style="cursor: pointer" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="info-s" *ngIf="dtcInfo">
      <table class="table table-bordered table-striped" style="border: none;">
        <thead style="font-weight: 600;background-color:cornsilk">
          <tr>
            <td class="title-column">ID</td>
            <td class="title-column">Module</td>
            <td class="title-column">Failure</td>
          </tr>
        </thead>
        <tr *ngFor="let u of dtcList" style="cursor: pointer;">
          <td class="row-mid title">{{u.dtcid}}</td>
          <td class="row-mid title">{{u.dtcModule}}</td>
          <td class="row-left title">{{u.failure}}</td>
        </tr>
      </table>
    </div>
    <div class="info-s" *ngIf="!dtcInfo">
        <p class="NoDTCInfo"> No DTC Information Available for the candiadte ID {{dtcCandidateId}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="buttons" (click)="modal.dismiss('Cross click');">{{'Close'|translate}}</button>
    </div>
  </div>
</ng-template>